import React from 'react';
import {
  Box,
  Typography,
  Button,
  Alert,
  AlertTitle,
  Paper,
} from '@mui/material';
import { ERROR_MESSAGES } from '../../config/constants';

interface InvalidSubdomainErrorProps {
  hostname: string;
}

const InvalidSubdomainError: React.FC<InvalidSubdomainErrorProps> = ({
  hostname,
}) => {
  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    // ✅ REDIRIGIR A UN DOMINIO VÁLIDO O PÁGINA PRINCIPAL
    window.location.href = 'https://makana-register.com'; // Ajustar según tu dominio principal
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 3,
        backgroundColor: 'grey.50',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 600,
          width: '100%',
          padding: 4,
          textAlign: 'center',
        }}
      >
        <Alert
          severity="error"
          sx={{
            marginBottom: 3,
            textAlign: 'left',
          }}
        >
          <AlertTitle>{ERROR_MESSAGES.SUBDOMAIN.INVALID_SUBDOMAIN}</AlertTitle>
          El subdominio <strong>{hostname}</strong>
          no está configurado en el sistema.
        </Alert>

        <Typography variant="h4" component="h1" gutterBottom color="error">
          {ERROR_MESSAGES.SUBDOMAIN.ACCESS_DENIED}
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          El subdominio que está intentando acceder no está configurado en
          nuestro sistema de registro. Esto puede deberse a:
        </Typography>

        <Box
          component="ul"
          sx={{
            textAlign: 'left',
            marginBottom: 3,
            paddingLeft: 2,
          }}
        >
          <Typography component="li" variant="body2" color="text.secondary">
            {ERROR_MESSAGES.SUBDOMAIN.REASONS.NOT_CONFIGURED_YET}
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            {ERROR_MESSAGES.SUBDOMAIN.REASONS.REMOVED}
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            {ERROR_MESSAGES.SUBDOMAIN.REASONS.DNS_ERROR}
          </Typography>
        </Box>

        <Typography variant="body1" color="text.secondary" paragraph>
          {ERROR_MESSAGES.SUBDOMAIN.CONTACT_ADMIN}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
            flexWrap: 'wrap',
            marginTop: 3,
          }}
        >
          <Button
            variant="contained"
            onClick={handleReload}
            color="primary"
            size="large"
          >
            Recargar página
          </Button>
          <Button
            variant="outlined"
            onClick={handleGoHome}
            color="secondary"
            size="large"
          >
            Ir al sitio principal
          </Button>
        </Box>

        {process.env.NODE_ENV === 'development' && (
          <Box
            sx={{
              marginTop: 3,
              padding: 2,
              backgroundColor: 'grey.100',
              borderRadius: 1,
              textAlign: 'left',
            }}
          >
            <Typography variant="caption" color="text.secondary">
              <strong>Información de desarrollo:</strong>
            </Typography>
            <Typography
              variant="caption"
              component="div"
              color="text.secondary"
            >
              Hostname: {hostname}
            </Typography>
            <Typography
              variant="caption"
              component="div"
              color="text.secondary"
            >
              URL: {window.location.href}
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default InvalidSubdomainError;
